import React from 'react'

import "./Invest.css"
import Accordion from './Accordion';

import { ReactComponent as Analysis } from '../assets/icons/analysis.svg'
import { ReactComponent as Entry } from '../assets/icons/entry.svg'
import { ReactComponent as Consolidate } from '../assets/icons/consolidate.svg'
import { ReactComponent as Care } from '../assets/icons/care.svg'

import { useTranslate } from '../Context/LanguageContext'

const Invest = () => {

    const t = useTranslate("invest")

    return (
        <div className='invest'>

            <div className='img' aria-hidden="true">
                <img
                    src='./images/invest.webp'
                    alt=""
                    loading='eager'
                    decoding='async'
                />
                <span className='overlay' />
            </div>

            <section className='start'>
                <div className='text'>
                    <div className='logo'>
                        <img
                            src="./images/logo3.svg"
                            alt="SINIS Logo"
                            decoding='async'
                        />
                        <p>SINIS</p>
                    </div>
                    <h1 className='title'>{t("title")}</h1>
                    <p className='heading'>
                        {t("heading1") + " "}
                        <span>{t("heading2")} </span>
                        {t("heading3") + " "}
                        <span>{t("heading4")} </span>
                        {t("heading5")}
                    </p>
                </div>
            </section>

            <section className='analysis'>

                <div className='wrapper'>

                    <div className='title'>
                        <Analysis aria-hidden="true" />
                        <div>
                            <h2 className='phase'>{t("phase1-title")}</h2>
                            <h3 className='subtitle'>{t("phase1-subtitle")}</h3>
                        </div>
                    </div>

                    <p className='description'>
                        {t("phase1-description")}
                    </p>

                    <div className='content'>
                        <Accordion
                            head={t("list1-1head")}
                            content={<>
                                <p className='bullet-point'>{t("list1-1bp1")}</p>
                                <p className='bullet-point'>{t("list1-1bp2")}</p>
                                <p className='bullet-point'>{t("list1-1bp3")}</p>
                                <p className='bullet-point'>{t("list1-1bp4")}</p>
                            </>}
                        />

                        <Accordion
                            head={t("list1-2head")}
                            content={<>
                                <p className='bullet-point'>{t("list1-2bp1")}</p>
                                <p className='bullet-point'>{t("list1-2bp2")}</p>
                                <p className='bullet-point'>{t("list1-2bp3")}</p>
                                <p className='bullet-point'>{t("list1-2bp4")}</p>
                            </>}
                        />

                        <Accordion
                            head={t("list1-3head")}
                            content={<>
                                <p className='bullet-point'>{t("list1-3bp1")}</p>
                                <p className='bullet-point'>{t("list1-3bp2")}</p>
                                <p className='bullet-point'>{t("list1-3bp3")}</p>
                                <p className='bullet-point'>{t("list1-3bp4")}</p>
                            </>}
                        />

                        <Accordion
                            head={t("list1-4head")}
                            content={<>
                                <p className='bullet-point'>{t("list1-4bp1")}</p>
                                <p className='bullet-point'>{t("list1-4bp2")}</p>
                                <p className='bullet-point'>{t("list1-4bp3")}</p>
                                <p className='bullet-point'>{t("list1-4bp4")}</p>
                            </>}
                        />
                    </div>

                </div>

            </section>


            <section className='entry'>

                <div className='wrapper'>
                    <div className='title'>
                        <Entry aria-hidden="true" />
                        <div>
                            <h2 className='phase'>{t("phase2-title")}</h2>
                            <h3 className='subtitle'>{t("phase2-subtitle")}</h3>
                        </div>
                    </div>

                    <p className='description'>
                        {t("phase2-description")}
                    </p>

                    <div className='content'>
                        <Accordion
                            head={t("list2-1head")}
                            content={<>
                                <p className='bullet-point'>{t("list2-1bp1")}</p>
                                <p className='bullet-point'>{t("list2-1bp2")}</p>
                                <p className='bullet-point'>{t("list2-1bp3")}</p>
                                <p className='bullet-point'>{t("list2-1bp4")}</p>
                                <p className='bullet-point'>{t("list2-1bp5")}</p>
                                <p className='bullet-point'>{t("list2-1bp6")}</p>
                                <p className='bullet-point'>{t("list2-1bp7")}</p>
                            </>}
                        />
                        <Accordion
                            head={t("list2-2head")}
                            content={<>
                                <p className='bullet-point'>{t("list2-2bp1")}</p>
                                <p className='bullet-point'>{t("list2-2bp2")}</p>
                                <p className='bullet-point'>{t("list2-2bp3")}</p>
                                <p className='bullet-point'>{t("list2-2bp4")}</p>
                                <p className='bullet-point'>{t("list2-2bp5")}</p>
                            </>}
                        />
                    </div>
                </div>

            </section>


            <section className='consolidate'>
                <div className='wrapper'>
                    <div className='title'>
                        <Consolidate aria-hidden="true" />
                        <div>
                            <h2 className='phase'>{t("phase3-title")}</h2>
                            <h3 className='subtitle'>{t("phase3-subtitle")}</h3>
                        </div>
                    </div>

                    <div className='content'>
                        <Accordion
                            head={t("list3-1head")}
                            content={<>
                                <p className='bullet-point'>{t("list3-1bp1")}</p>
                                <p className='bullet-point'>{t("list3-1bp2")}</p>
                                <p className='bullet-point'>{t("list3-1bp3")}</p>
                                <p className='bullet-point'>{t("list3-1bp4")}</p>
                                <p className='bullet-point'>{t("list3-1bp5")}</p>
                            </>}
                        />

                        <Accordion
                            head={t("list3-2head")}
                            content={<>
                                <p className='bullet-point'>{t("list3-2bp1")}</p>
                                <p className='bullet-point'>{t("list3-2bp2")}</p>
                            </>}
                        />

                        <Accordion
                            head={t("list3-3head")}
                            content={<>
                                <p className='bullet-point'>{t("list3-3bp1")}</p>
                                <p className='bullet-point'>{t("list3-3bp2")}</p>
                                <p className='bullet-point'>{t("list3-3bp3")}</p>
                            </>}
                        />

                        <Accordion
                            head={t("list3-4head")}
                            content={<>
                                <p className='bullet-point'>{t("list3-4bp1")}</p>
                                <p className='bullet-point'>{t("list3-4bp2")}</p>
                                <p className='bullet-point'>{t("list3-4bp3")}</p>
                                <p className='bullet-point'>{t("list3-4bp4")}</p>
                            </>}
                        />

                        <Accordion
                            head={t("list3-5head")}
                            content={<>
                                <p className='bullet-point'>{t("list3-5bp1")}</p>
                                <p className='bullet-point'>{t("list3-5bp2")}</p>
                                <p className='bullet-point'>{t("list3-5bp3")}</p>
                            </>}
                        />

                        <Accordion
                            head={t("list3-6head")}
                            content={<>
                                <p className='bullet-point'>{t("list3-6bp1")}</p>
                                <p className='bullet-point'>{t("list3-6bp2")}</p>
                            </>}
                        />
                    </div>
                </div>
            </section>

            <section className='care'>

                <div className='wrapper'>
                    <div className='title'>
                        <Care aria-hidden="true" />
                        <div>
                            <h2 className='phase'>{t("phase4-title")}</h2>
                            <h3 className='subtitle'>{t("phase4-subtitle")}</h3>
                        </div>
                    </div>

                    <p className='description'>
                        {t("phase4-description")}
                    </p>

                    <div className='list'>
                        <p className='head'> {t("list4-head")} </p>
                        <p className='bullet-point'>{t("list4-bp1")}</p>
                        <p className='bullet-point'>{t("list4-bp2")}</p>
                        <p className='bullet-point'>{t("list4-bp3")}</p>
                        <p className='bullet-point'>{t("list4-bp4")}</p>
                        <p className='bullet-point'>{t("list4-bp5")}</p>
                        <p className='bullet-point'>{t("list4-bp6")}</p>
                    </div>
                </div>

            </section>
        </div>
    );
}

export default Invest;